import { postData } from "../api-client";
import {
  ADD_JOB_ANALYSIS,
  WEB_USER,
} from "../../shared/constants/routing-constants";

export function postAnalysis(jsonData: any) {
  return postData(`${WEB_USER}/${ADD_JOB_ANALYSIS}`, jsonData);
}
